import { BooleanInput, Create, SimpleForm, TextInput } from "react-admin";




export function EmailDomainCreate() {
    return (
        <Create>
            <SimpleForm>
                <TextInput source="id" label={"Domain"} />
                <BooleanInput source="isDisposable" defaultValue={true} />
            </SimpleForm>
        </Create>
    )
}